import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

// Enviroment
import { environment } from 'src/environments/environment';

// Services
import { SharedService } from 'src/app/services/shared.service';
import { catchError, first, take } from 'rxjs/operators';
import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root'
})

export class HttpService {

  public urlHttps: string = environment.baseUrl;

  private responseData: any;

  private userId: string = '';
  private token: string = '';
  private companyId: string = '';

  constructor(
    private _http: HttpClient,
    private _sharedService: SharedService
    ) { }

  getData(): void {
    // this.userId = '46';
    // this.token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjo0Nn0sImlhdCI6MTU5NTk2NTY0OX0.19vKw6uSJyc6-NOFF2834gx7RFMJT-LPj7CZzoDPsnw';
    this.userId = localStorage.getItem('uid')   ? localStorage.getItem('uid') : '';
    this.token  = localStorage.getItem('token') ? localStorage.getItem('token') : '';
    // if( !(this.userId && this.token) ) this._sharedService.logOutUser();
  }

  getHeaders( headers_ ?: any ): HttpHeaders {
    this.getData();
    let headers: HttpHeaders = new HttpHeaders();
    if(headers_) headers = new HttpHeaders(headers_);
    headers = headers.append('cli', 'Web');
    headers = headers.append('uid', this.userId);
    headers = headers.append('token', this.token);
    return headers;
  }

  httpGet(url: string, headers_?: any) {
    let headers : any = this.getHeaders(headers_); 
    return this._http.get(this.urlHttps + url, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
    
  }

  httpPost(url: string, data: any, headers_?: any) {
    let headers : any = this.getHeaders(headers_);
    return this._http.post(this.urlHttps + url, data, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
  }

  httpPostLogin(url: string, data: any, headers_?: any) {
    let headers : any = new HttpHeaders({
      'cli': 'Web'
    });
    return this._http.post(this.urlHttps + url, data, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
  }

  httpDelete(url: string, headers_?: any) {
    let headers : any = this.getHeaders(headers_);
    return this._http.delete(this.urlHttps + url, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
  }

  httpPatch(url: string, data: any, headers_?: any) {
    let headers : any = this.getHeaders(headers_);
    return this._http.patch(this.urlHttps + url, data, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
  }

  httpPut(url: string, data: any, headers_?: any) {
    let headers : any = this.getHeaders(headers_);
    return this._http.put(this.urlHttps + url, data, { headers }).pipe(
      take(1),
      catchError((error: HttpErrorResponse) => this.catchErrorNoAutenticated(error))
    );
  }

  catchErrorNoAutenticated(error: HttpErrorResponse){
      // if (error.status == 401 || error.status == 403) {
      if (error.status == 403) {
        alert('Su sesión a terminado.');
        let modality = localStorage.getItem('modality')
        let table  = localStorage.getItem('table_user')
        let clientId  = localStorage.getItem('clientId')
        let companyId = localStorage.getItem('companyId')
        this._sharedService.closeSession();
        let route = '/';
        if(modality == 'salon'){
          route = `/#/menu/empresa/${clientId}/compania/${companyId}/modalidad/salon/mesa/${table}`;
        }
        location.href = route;
        return throwError(error);
      }
      return throwError(error);
  }

}